import { Box, IconButton, Stack } from '@mui/material';
import binIcon from 'assets/icons/bin-icon.svg';
import penIcon from 'assets/icons/pen-icon.svg';
import { DeleteConfirmationModal } from 'components/DeleteConfirmationModal';
import { TertiaryButton } from 'components/lib/TertiaryButton';
import { SvgIconWrapper } from 'components/SvgIconWrapper';
import { castArray, isUndefined } from 'lodash-es';
import { type FC, useState } from 'react';
import {
  ExposuresListItemContentWrapperStyle,
  ExposuresListItemEditBtnStyle,
  ExposuresListItemStyle,
} from './ExposuresListItem.styles';
import type { ExposuresListItemProps } from './ExposuresListItem.types';

const ExposuresListItem: FC<ExposuresListItemProps> = ({
  children,
  title,
  category,
  onDelete,
  onEdit,
  onDeleteIconClicked,
  ...rest
}) => {
  const [isDeleting, setIsDeleting] = useState(false);

  const toggleIsDeleting = () => {
    setIsDeleting((prevValue) => !prevValue);
  };

  const onClickDeleteIcon = () => {
    if (!isUndefined(onDeleteIconClicked)) {
      const openDeleteModal = onDeleteIconClicked();

      if (openDeleteModal) {
        toggleIsDeleting();
      }
    } else {
      toggleIsDeleting();
    }
  };

  return (
    <Box {...rest} sx={[ExposuresListItemStyle, ...castArray(rest.sx)]}>
      <Stack sx={ExposuresListItemContentWrapperStyle}>
        <TertiaryButton
          text={title}
          underline
          onClick={onEdit}
          endAdornment={<SvgIconWrapper src={penIcon} />}
          sx={ExposuresListItemEditBtnStyle}
        />

        {children}
      </Stack>

      <IconButton disableRipple onClick={onClickDeleteIcon}>
        <SvgIconWrapper src={binIcon} />
      </IconButton>

      <DeleteConfirmationModal
        open={isDeleting}
        deletingElementCategory={category}
        deletingElementTitle={title}
        handleDelete={onDelete}
        onCloseIconClick={toggleIsDeleting}
        onClose={toggleIsDeleting}
      />
    </Box>
  );
};

export default ExposuresListItem;
